import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.71436 12.3846C6.16207 12.3846 5.71436 11.9369 5.71436 11.3846L5.71436 7.92308C5.71436 7.37079 6.16207 6.92308 6.71436 6.92308C7.26664 6.92308 7.71436 7.37079 7.71436 7.92308L7.71436 11.3846C7.71436 11.9369 7.26664 12.3846 6.71436 12.3846Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.28564 7.76923C2.28564 6.66466 3.18108 5.76923 4.28564 5.76923H13.7142C14.8188 5.76923 15.7142 6.66466 15.7142 7.76923V15C15.7142 16.1046 14.8188 17 13.7142 17H4.28565C3.18108 17 2.28564 16.1046 2.28564 15V7.76923ZM13.7142 7.76923L4.28564 7.76923V15H13.7142L13.7142 7.76923Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.1431 11.2308C9.59078 11.2308 9.14307 10.7831 9.14307 10.2308V6.76923C9.14307 6.21695 9.59078 5.76923 10.1431 5.76923C10.6954 5.76923 11.1431 6.21695 11.1431 6.76923V10.2308C11.1431 10.7831 10.6954 11.2308 10.1431 11.2308Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0 2.5C0 1.11929 1.11929 0 2.5 0H15.5C16.8807 0 18 1.11929 18 2.5V5.26923C18 6.64994 16.8807 7.76923 15.5 7.76923H2.5C1.11929 7.76923 0 6.64994 0 5.26923V2.5ZM2.5 2C2.22386 2 2 2.22386 2 2.5V5.26923C2 5.54537 2.22386 5.76923 2.5 5.76923H15.5C15.7761 5.76923 16 5.54537 16 5.26923V2.5C16 2.22386 15.7761 2 15.5 2H2.5Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}